<template>
    <div>
        <div class="loader" v-if="loading"></div>
        <div class="card-deck">

            <div class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25">
                <stats-card data-background-color="blue">
                    <template slot="header">
                        <md-icon>school</md-icon>
                    </template>

                    <template slot="content">
                        <h5 class="category">
                            {{$t('registers.events.generalData.participantsMaxNum')}}
                        </h5>
                        <h4 class="title">{{ model.studentsMaxNum ? model.studentsMaxNum : 0 }}</h4>
                    </template>
                </stats-card>
            </div>
            <div class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25">
                <stats-card data-background-color="blue">
                    <template slot="header">
                        <md-icon>how_to_reg</md-icon>
                    </template>

                    <template slot="content">
                        <h5 class="category">{{ $t('registers.events.evaluation.tempRanking.admitted') }}</h5>
                        <h4 class="title">{{ model.admittedCount ? model.admittedCount : 0 }}</h4>
                    </template>
                </stats-card>
            </div>
            <div class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25">
                <stats-card data-background-color="blue">
                    <template slot="header">
                        <md-icon>how_to_reg</md-icon>
                    </template>

                    <template slot="content">
                        <h5 class="category">{{ $t('registers.participants.title') }}</h5>
                        <h4 class="title">{{ model.participantsCount ? model.participantsCount : 0 }}</h4>
                    </template>
                </stats-card>
            </div>
            <div class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25">
                <stats-card data-background-color="green">
                    <template slot="header">
                        <md-icon>school</md-icon>
                    </template>

                    <template slot="content">
                        <h5 class="category">{{ $t('registers.participants.freeSeats') }}</h5>
                        <h4 class="title">{{ freeSeats }}</h4>
                    </template>
                </stats-card>
            </div>
        </div>
    </div>
</template>

<script>
    import { TempRankingStatistics } from '@/models/models';
    import StatsCard from '@/components/cards/StatsCard';
    import tempRankingService from '@/services/tempRanking.service';


    export default {
        components: {
            StatsCard
        },
        props: {
            tempRankingId: {
                type: Number,
                required: true,
            }
        },
        data() {
            return {
                loading: false,
                model: new TempRankingStatistics(),
            };
        },
        methods: {
            loadStatistics() {
                tempRankingService
                    .getStatistics(this.tempRankingId)
                    .then(response => {
                        this.loading = false;

                        if (response.data) {
                            this.model = new TempRankingStatistics(response.data);
                        }
                        this.loading = false;
                    });
            },
            reload() {
                this.loadStatistics();
            }
        },
        mounted() {
            this.loadStatistics();
        },
        computed: {
            freeSeats() {
                const max = Number(this.model.studentsMaxNum);
                const admitted = Number(this.model.admittedCount);

                return (max || 0) - (admitted || 0);
            }
        }

    };
</script>

<style lang="scss" scoped>
</style>
